/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import getData, { type Project } from './getData.tsx';

const RESOURCE_TYPE_CSM_BASE_URL = 'L1_CUSTOMERS_PROJECT';

export const l1CustomersProjectProviderResource: RouteResource<Project | null> =
	createResource<Project | null>({
		type: RESOURCE_TYPE_CSM_BASE_URL,
		getKey: () => 'l1-customers-project',
		getData: async () => getData(),
		maxAge: 60 * 60 * 1000, // 1 hour
	});
